import {
  Button,
  Col,
  Form,
  Modal,
  Row,
  Select,
  Tooltip,
  Typography,
} from 'antd';
import { capitalize } from 'lodash';
import React, { useCallback } from 'react';

import { AddressType, Terminal } from '../../models/Terminal';

interface IProps {
  terminals: Terminal[];
  type: AddressType;
  onClose: () => void;
  onSubmit: (terminals: Array<number>) => void;
  initialTerminals?: Array<any>;
}

const OrgDestTerminalAssignModal: React.FC<IProps> = ({
  initialTerminals = [],
  onClose,
  onSubmit,
  terminals,
  type,
}) => {
  const [form] = Form.useForm<{ terminals: Array<number> }>();

  const closeModal = useCallback(() => {
    form.resetFields();
    onClose();
  }, [form, onClose]);

  const submitModal = useCallback(
    (formState: { terminals: Array<number> }) => {
      onSubmit(formState.terminals);
    },
    [onSubmit]
  );

  const terminalIds: Array<number> = initialTerminals
    .map((term) =>
      typeof term === 'object' && term !== null ? term.id : term
    )
    .filter((id): id is number => id != null);

  return (
    <Modal
      centered
      footer={null}
      maskClosable={false}
      title="Assign Terminal"
      visible={true}
      width={600}
      onCancel={closeModal}
    >
      <Form
        form={form}
        initialValues={{ terminals: terminalIds }}
        layout="vertical"
        onFinish={submitModal}
      >
        <Row gutter={16}>
          <Col flex={1}>
            <Form.Item label={capitalize(type)} name="terminals">
              <Select
                maxTagCount="responsive"
                maxTagPlaceholder={(omittedValues) =>
                  omittedValues.length > 0 ? (
                    <Tooltip
                      title={omittedValues.map(({ label }) => label).join(', ')}
                    >
                      <span>
                        {omittedValues[0]?.label}
                        {omittedValues.length > 1 &&
                          ` + ${omittedValues.length - 1} more...`}
                      </span>
                    </Tooltip>
                  ) : null
                }
                mode="multiple"
                optionLabelProp="label"
                placeholder="Select Terminals"
                style={{ width: '100%' }}
              >
                {terminals.map((terminal) => (
                  <Select.Option
                    key={terminal.id}
                    label={terminal.name}
                    value={terminal.id}
                  >
                    <Typography.Text className="terminal-assign-modal__terminal-name">
                      {terminal.name}
                    </Typography.Text>
                    <Typography.Text
                      className="terminal-assign-modal__terminal-info"
                      type="secondary"
                    >
                      {terminal.address1} {terminal.address2}, {terminal.city}{' '}
                      {terminal.state}, {terminal.zipCode}
                    </Typography.Text>
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col>
            <Form.Item label=" ">
              <Button
                className="modal-save-btn"
                htmlType="submit"
                type="primary"
              >
                SAVE
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default OrgDestTerminalAssignModal;
